<p-toast></p-toast>

<!-- Skeleton loading state -->
<div class="preview-container" *ngIf="loading">
    <!-- Header skeleton -->
    <div class="preview-header">
        <div class="flex justify-content-between align-items-center">
            <div class="header-title">
                <i class="pi pi-file-text text-3xl"></i>
                <h1 class="ml-3">Detalles de Cotización Calculada</h1>
            </div>
            <div class="header-actions">
                <p-skeleton width="140px" height="40px"></p-skeleton>
            </div>
        </div>
    </div>

    <!-- Cards grid skeleton -->
    <div class="preview-content">
        <div class="cards-grid">
            <!-- Client info card skeleton -->
            <div class="info-card">
                <div class="card-header">
                    <i class="pi pi-user"></i>
                    <h3>Información del Cliente</h3>
                    <div class="header-tags">
                        <p-skeleton width="80px" height="24px"></p-skeleton>
                    </div>
                </div>
                <div class="card-content">
                    <div class="client-basic-info">
                        <div class="client-avatar">
                            <p-skeleton shape="circle" size="60px"></p-skeleton>
                        </div>
                        <div class="client-details">
                            <p-skeleton width="180px" height="24px" class="mb-3"></p-skeleton>
                            <div class="client-meta">
                                <div class="meta-item">
                                    <p-skeleton width="200px" height="18px"></p-skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Assets info card skeleton -->
            <div class="info-card assets-enhanced-card">
                <div class="card-header">
                    <i class="pi pi-box"></i>
                    <h3>Información de Activos</h3>
                    <div class="header-tags">
                        <p-skeleton width="90px" height="24px"></p-skeleton>
                    </div>
                </div>
                <div class="card-content">
                    <div class="assets-financial-container">
                        <div class="assets-list-section">
                            <p-skeleton width="180px" height="18px" class="mb-3"></p-skeleton>
                            <p-skeleton width="120px" height="16px" class="mb-2"></p-skeleton>
                        </div>
                        <div class="financial-summary-section">
                            <p-skeleton width="140px" height="18px" class="mb-3"></p-skeleton>
                            <div class="financial-summary-card">
                                <div class="financial-breakdown">
                                    <div class="breakdown-row">
                                        <p-skeleton width="100px" height="16px"></p-skeleton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Financial config card skeleton -->
        <div class="info-card wide-card">
            <div class="card-header">
                <i class="pi pi-calculator"></i>
                <h3>Detalles Financieros</h3>
            </div>
            <div class="card-content">
                <div class="financial-grid">
                    <div class="financial-item" *ngFor="let item of [1,2,3,4,5,6]">
                        <p-skeleton width="140px" height="14px" class="mb-2"></p-skeleton>
                        <p-skeleton width="80px" height="20px"></p-skeleton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main content -->
<div class="preview-container" *ngIf="calculatedQuote && !loading">
    <!-- Header with client info and download button -->
    <div class="preview-header" *ngIf="hasClientInfo()">
        <div class="flex justify-content-between align-items-center">
            <div class="header-title">
                <i class="pi pi-file-text text-3xl text-primary"></i>
                <h1 class="ml-3">Detalles de Cotización Calculada</h1>
            </div>
            <div class="header-actions">
                <button 
                    pButton 
                    type="button" 
                    icon="fa-regular fa-file-pdf" 
                    class="pdf-button p-button-danger"
                    (click)="downloadPDF()"
                    pTooltip="Descargar PDF"
                    tooltipPosition="top">
                </button>
            </div>
        </div>
    </div>

    <!-- Content cards -->
    <div class="preview-content">
        <!-- First row: Client and Assets info only -->
        <div class="cards-grid">
            <!-- Client Information Card -->
            <div class="info-card">
                <div class="card-header">
                    <i class="pi pi-user text-indigo-600"></i>
                    <h3>Información del Cliente</h3>
                    <div class="header-tags">
                        <p-tag 
                            *ngIf="calculatedQuote.client" 
                            value="Definitivo" 
                            severity="success"
                            class="client-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="!calculatedQuote.client" 
                            value="Provisional" 
                            severity="warning"
                            class="client-tag">
                        </p-tag>
                    </div>
                </div>
                <div class="card-content">
                    <!-- Client Basic Info -->
                    <div class="client-basic-info">
                        <div class="client-avatar">
                            <i class="pi pi-user text-4xl text-indigo-500"></i>
                        </div>
                        <div class="client-details">
                            <h4 class="client-name">{{ getClientName() }}</h4>
                            <div class="client-meta" *ngIf="calculatedQuote.client">
                                <div class="meta-item" *ngIf="calculatedQuote.client.email">
                                    <i class="pi pi-envelope text-gray-500"></i>
                                    <span class="meta-value">{{ calculatedQuote.client.email }}</span>
                                </div>
                                <div class="meta-item" *ngIf="calculatedQuote.client.phone">
                                    <i class="pi pi-phone text-gray-500"></i>
                                    <span class="meta-value">{{ calculatedQuote.client.phone }}</span>
                                </div>
                                <div class="meta-item" *ngIf="calculatedQuote.client._id">
                                    <i class="pi pi-id-card text-gray-500"></i>
                                    <span class="meta-value client-id">ID: {{ calculatedQuote.client._id.slice(-8) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Quote Timeline -->
                    <div class="quote-timeline">
                        <div class="timeline-header">
                            <i class="pi pi-clock text-blue-600"></i>
                            <span class="timeline-title">Historial de Cotización</span>
                        </div>
                        <div class="timeline-items">
                            <div class="timeline-item created">
                                <div class="timeline-marker created-marker">
                                    <i class="pi pi-plus-circle"></i>
                                </div>
                                <div class="timeline-content">
                                    <span class="timeline-label">Creada</span>
                                    <span class="timeline-date">{{ calculatedQuote.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                </div>
                            </div>
                            <div class="timeline-item updated" *ngIf="calculatedQuote.updatedAt !== calculatedQuote.createdAt">
                                <div class="timeline-marker updated-marker">
                                    <i class="pi pi-pencil"></i>
                                </div>
                                <div class="timeline-content">
                                    <span class="timeline-label">Actualizada</span>
                                    <span class="timeline-date">{{ calculatedQuote.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Assets Information Card - Enhanced and Double Width -->
            <div class="info-card assets-enhanced-card">
                <div class="card-header">
                    <i class="pi pi-box text-blue-600"></i>
                    <h3>Información de Activos</h3>
                    <div class="header-tags">
                        <p-tag 
                            [value]="getTotalAssetsCount() + ' activo(s)'" 
                            severity="info" 
                            class="count-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="hasDefinitiveAssets()" 
                            value="Definitivos" 
                            severity="success"
                            class="assets-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="!hasDefinitiveAssets()" 
                            value="Provisional" 
                            severity="warning"
                            class="assets-tag">
                        </p-tag>
                    </div>
                </div>
                <div class="card-content">
                    <!-- Provisional Assets View -->
                    <div *ngIf="!hasDefinitiveAssets()" class="provisional-assets">
                        <div class="provisional-banner">
                            <div class="provisional-icon">
                                <i class="pi pi-exclamation-triangle text-4xl text-orange-500"></i>
                            </div>
                            <div class="provisional-info">
                                <h4 class="provisional-title">{{ calculatedQuote.assetsNames || 'Activo no especificado' }}</h4>
                                <p class="provisional-subtitle">Información provisional pendiente de confirmar</p>
                                <div class="provisional-value-display">
                                    <span class="value-label">Valor estimado</span>
                                    <span class="value-amount">{{ calculatedQuote.assetsValue.total | currency:'MXN':'symbol':'1.2-2' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Definitive Assets View - Horizontal Layout -->
                    <div *ngIf="hasDefinitiveAssets()" class="definitive-assets-horizontal">
                        <!-- Assets Summary Bar - Horizontal with Better Spacing -->
                        <div class="assets-summary-bar-horizontal">
                            <div class="summary-stat">
                                <i class="pi pi-tags text-blue-600"></i>
                                <div class="stat-content">
                                    <span class="stat-label">Categorías</span>
                                    <span class="stat-value">{{ getAssetsCategorySummary() || 'No especificada' }}</span>
                                </div>
                            </div>
                            <div class="summary-stat">
                                <i class="pi pi-calendar text-green-600"></i>
                                <div class="stat-content">
                                    <span class="stat-label">Registrados</span>
                                    <span class="stat-value">{{ formatDate(getDefinitiveAssets()[0]?.createdAt) || 'Fecha no disponible' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Assets and Financial Layout - Two Column with Better Structure -->
                        <div class="assets-financial-container">
                            <!-- Left Column: Assets List -->
                            <div class="assets-list-section">
                                <div class="section-header">
                                    <div class="section-title">
                                        <i class="pi pi-list text-blue-600"></i>
                                        <h4>Activos Incluidos</h4>
                                    </div>
                                </div>
                                
                                <!-- Detailed Assets List - Improved Horizontal Cards -->
                                <div *ngIf="hasDetailedAssets()" class="assets-list-container">
                                    <div class="asset-card-improved" *ngFor="let asset of getDefinitiveAssets(); let i = index; trackBy: trackByAssetId">
                                        <!-- Asset Header with Clear Hierarchy -->
                                        <div class="asset-header-section">
                                            <div class="asset-identity">
                                                <div class="asset-number">{{ i + 1 }}</div>
                                                <div class="asset-name-section">
                                                    <h5 class="asset-name">{{ asset.name }}</h5>
                                                    <div class="asset-status-badges">
                                                        <span class="category-badge">{{ asset.category }}</span>
                                                        <span class="status-badge" [ngClass]="getAssetStatusClass(asset.status)">
                                                            {{ asset.status || 'Sin estado' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="asset-value-section">
                                                <span class="asset-total-value" *ngIf="asset.acquisition">
                                                    {{ asset.acquisition.total | currency:'MXN':'symbol':'1.0-0' }}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Asset Details Grid - Better Organized -->
                                        <div class="asset-details-section" *ngIf="asset.brand || asset.assetModel || asset.serie || asset.color">
                                            <div class="details-grid">
                                                <div class="detail-chip" *ngIf="asset.brand"
                                                     pTooltip="Marca: {{ asset.brand }}" 
                                                     tooltipPosition="top">
                                                    <span class="chip-icon">🏷️</span>
                                                    <span class="chip-text">{{ asset.brand }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.assetModel"
                                                     pTooltip="Modelo: {{ asset.assetModel }}" 
                                                     tooltipPosition="top">
                                                    <span class="chip-icon">🔧</span>
                                                    <span class="chip-text">{{ asset.assetModel }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.serie"
                                                     pTooltip="Número de Serie: {{ asset.serie }}" 
                                                     tooltipPosition="top">
                                                    <span class="chip-icon">🔢</span>
                                                    <span class="chip-text">{{ asset.serie }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.color"
                                                     pTooltip="Color: {{ asset.color }}" 
                                                     tooltipPosition="top">
                                                    <span class="chip-icon">🎨</span>
                                                    <span class="chip-text">{{ asset.color }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.version"
                                                     pTooltip="Versión: {{ asset.version }}" 
                                                     tooltipPosition="top">
                                                    <span class="chip-icon">📋</span>
                                                    <span class="chip-text">{{ asset.version }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.engineNumber"
                                                     pTooltip="Número de Motor: {{ asset.engineNumber }}" 
                                                     tooltipPosition="top">
                                                    <span class="chip-icon">⚙️</span>
                                                    <span class="chip-text">{{ asset.engineNumber }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Simple Assets List - if no detailed info -->
                                <div *ngIf="!hasDetailedAssets()" class="simple-assets-container">
                                    <div class="simple-asset-item" *ngFor="let asset of getDefinitiveAssets()">
                                        <i class="pi pi-box text-blue-500"></i>
                                        <span class="simple-asset-name">{{ asset.name || asset }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Column: Financial Summary -->
                            <div class="financial-summary-section">
                                <div class="section-header">
                                    <div class="section-title">
                                        <i class="pi pi-calculator text-green-600"></i>
                                        <h4>Resumen Financiero</h4>
                                    </div>
                                </div>
                                
                                <div class="financial-summary-card">
                                    <div class="financial-breakdown">
                                        <div class="breakdown-row subtotal-row">
                                            <span class="breakdown-label">Subtotal</span>
                                            <span class="breakdown-value">{{ calculatedQuote.assetsValue.amount | currency }}</span>
                                        </div>
                                        <div class="breakdown-row iva-row">
                                            <span class="breakdown-label">IVA</span>
                                            <span class="breakdown-value">{{ calculatedQuote.assetsValue.iva | currency }}</span>
                                        </div>
                                        <div class="breakdown-separator"></div>
                                        <div class="breakdown-row total-row">
                                            <span class="breakdown-label">Total</span>
                                            <span class="breakdown-value total-amount">{{ calculatedQuote.assetsValue.total | currency }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Financial Details Card - Full Width --> 
        <div class="info-card wide-card">
            <div class="card-header">
                <i class="pi pi-calculator text-green-600"></i>
                <h3>Detalles Financieros</h3>
            </div>
            <div class="card-content">
                <div class="financial-grid">
                    <div class="financial-item">
                        <span class="label">Anticipo:</span>
                        <span class="value financial-value">{{ calculatedQuote.advance.percentage | number: '1.2-2' }}% ({{ calculatedQuote.advance.total | currency }})</span>
                    </div>

                    <div class="financial-item">
                        <span class="label">Comisión de apertura:</span>
                        <span class="value financial-value">{{ calculatedQuote.openingCommission.percentage | number: '1.2-2' }}% ({{ calculatedQuote.openingCommission.total | currency }})</span>
                    </div>

                    <div class="financial-item">
                        <span class="label">Monto a financiar:</span>
                        <span class="value financial-value">{{ calculatedQuote.amountToFinance | currency }}</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Tasa de interés:</span>
                        <span class="value financial-value">{{ calculatedQuote.interestRate | number: '1.2-2' }}%</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Gastos ratificación:</span>
                        <span class="value financial-value">{{ calculatedQuote.ratificationExpenses | currency }}</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Rentas anticipadas:</span>
                        <span class="value financial-value">{{ calculatedQuote.advancedRents }} meses</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Provisión PE:</span>
                        <span class="value financial-value">{{ calculatedQuote.provisionPe | number: '1.2-2' }}%</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Term Data (Selected Term with calculations) -->
        <div class="info-card wide-card term-selected-card" *ngIf="calculatedQuote.termData">
            <div class="card-header">
                <i class="pi pi-check-circle text-green-600"></i>
                <h3>Término Seleccionado - {{ calculatedQuote.termData.term }} meses</h3>
                <div class="header-tags">
                    <p-tag value="Seleccionado" severity="success"></p-tag>
                </div>
            </div>
            <div class="card-content">
                <!-- Key Financial Metrics -->
                <div class="financial-grid">
                    <div class="financial-item">
                        <span class="label">TIR:</span>
                        <span class="value financial-value highlight">{{ calculatedQuote.termData.irr | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">TIR Ajustada:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData.irrAdjusted | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">Tasa Comercial:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData.commercialRate | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">Factor de Arrendamiento:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData.leaseFactor | number: '1.4-4' }}</span>
                    </div>
                </div>

                <!-- Payment Details in Three Columns -->
                <div class="payment-details-grid">
                    <!-- Monthly Rent -->
                    <div class="payment-detail-card">
                        <div class="payment-header">
                            <i class="pi pi-calendar text-blue-600"></i>
                            <h4>Renta Mensual</h4>
                        </div>
                        <div class="payment-breakdown" *ngIf="rentBreakdown(calculatedQuote.termData.rent) as rent">
                            <div class="breakdown-row">
                                <span class="breakdown-label">Renta</span>
                                <span class="breakdown-value">{{ rent.rent | currency }}</span>
                            </div>
                            <ng-container *ngIf="rent.hasAccessories">
                                <div class="breakdown-row">
                                    <span class="breakdown-label">Accesorios</span>
                                    <span class="breakdown-value">{{ rent.accessories | currency }}</span>
                                </div>
                                <div class="breakdown-row">
                                    <span class="breakdown-label">Subtotal (sin IVA)</span>
                                    <span class="breakdown-value">{{ rent.subtotal | currency }}</span>
                                </div>
                            </ng-container>
                            <div class="breakdown-row">
                                <span class="breakdown-label">IVA</span>
                                <span class="breakdown-value">{{ rent.iva | currency }}</span>
                            </div>
                            <div class="breakdown-separator"></div>
                            <div class="breakdown-row total-row">
                                <span class="breakdown-label">Total</span>
                                <span class="breakdown-value total-amount">{{ rent.total | currency }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Residual Value -->
                    <div class="payment-detail-card">
                        <div class="payment-header">
                            <i class="pi pi-wallet text-purple-600"></i>
                            <h4>Valor Residual ({{ calculatedQuote.termData.residuary.percentage | number: '1.2-2' }}%)</h4>
                            <p-tag *ngIf="calculatedQuote.termData.residuary.isPaid" value="Pagado" severity="success"></p-tag>
                        </div>
                        <div class="payment-breakdown">
                            <div class="breakdown-row">
                                <span class="breakdown-label">Monto</span>
                                <span class="breakdown-value">{{ calculatedQuote.termData.residuary.amount | currency }}</span>
                            </div>
                            <div class="breakdown-row">
                                <span class="breakdown-label">IVA</span>
                                <span class="breakdown-value">{{ calculatedQuote.termData.residuary.iva | currency }}</span>
                            </div>
                            <div class="breakdown-separator"></div>
                            <div class="breakdown-row total-row">
                                <span class="breakdown-label">Total</span>
                                <span class="breakdown-value total-amount">{{ calculatedQuote.termData.residuary.total | currency }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Down Payment -->
                    <div class="payment-detail-card">
                        <div class="payment-header">
                            <i class="pi pi-credit-card text-green-600"></i>
                            <h4>Enganche</h4>
                            <p-tag *ngIf="calculatedQuote.termData.downPayment.isPaid" value="Pagado" severity="success"></p-tag>
                        </div>
                        <div class="payment-breakdown">
                            <div class="breakdown-row">
                                <span class="breakdown-label">Monto</span>
                                <span class="breakdown-value">{{ calculatedQuote.termData.downPayment.amount | currency }}</span>
                            </div>
                            <div class="breakdown-row">
                                <span class="breakdown-label">IVA</span>
                                <span class="breakdown-value">{{ calculatedQuote.termData.downPayment.iva | currency }}</span>
                            </div>
                            <div class="breakdown-separator"></div>
                            <div class="breakdown-row total-row">
                                <span class="breakdown-label">Total</span>
                                <span class="breakdown-value total-amount">{{ calculatedQuote.termData.downPayment.total | currency }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Total Payment Highlight -->
                <div class="total-lease-payment">
                    <div class="total-payment-card">
                        <div class="total-payment-header">
                            <i class="pi pi-money-bill text-4xl text-green-600"></i>
                            <h4>Pago Total del Arrendamiento</h4>
                        </div>
                        <div class="total-payment-amount">
                            {{ calculatedQuote.termData.totalLeasePayment | currency }}
                        </div>
                        <div class="total-payment-note" *ngIf="calculatedQuote.termData?.taxSavingsIncomeDeductibility">
                            <i class="pi pi-info-circle text-blue-600"></i>
                            <span>Ahorro Fiscal: {{ calculatedQuote.termData.taxSavingsIncomeDeductibility | number: '1.2-2' }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Amortization Table Card -->
        <div class="info-card wide-card" *ngIf="getAmortizationPeriods().length > 0">
            <div class="card-header">
                <i class="pi pi-table text-purple-600"></i>
                <h3>Tabla de Amortización</h3>
                <div class="header-tags">
                    <p-tag [value]="getAmortizationPeriods().length + ' períodos'" severity="info"></p-tag>
                </div>
            </div>
            <div class="card-content">
                <div class="table-container">
                    <p-table [value]="getAmortizationPeriods()" [scrollable]="true" scrollHeight="400px" styleClass="p-datatable-sm amortization-table">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="text-center">#</th>
                                <th class="text-center">Fecha</th>
                                <th class="text-center">Renta</th>
                                <th class="text-center">Capital</th>
                                <th class="text-center">Interés</th>
                                <th class="text-center">Accesorios</th>
                                <th class="text-center">Pago Total</th>
                                <th class="text-center">Saldo Pendiente</th>
                                <th class="text-center">Estado</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-period>
                            <tr>
                                <td class="text-center">{{ period.period }}</td>
                                <td class="text-center">{{ period.date | date:'dd/MM/yyyy' }}</td>
                                <td class="text-right">{{ period.rent | currency }}</td>
                                <td class="text-right">{{ period.capital | currency }}</td>
                                <td class="text-right">{{ period.interest | currency }}</td>
                                <td class="text-right">{{ period.accessoriesAmount | currency }}</td>
                                <td class="text-right font-bold">{{ period.payment | currency }}</td>
                                <td class="text-right">{{ period.outstandingBalance | currency }}</td>
                                <td class="text-center">
                                    <p-tag 
                                        [value]="period.status === 'PAID' ? 'Pagado' : period.status === 'OVERDUE' ? 'Vencido' : 'Pendiente'"
                                        [severity]="period.status === 'PAID' ? 'success' : period.status === 'OVERDUE' ? 'danger' : 'warning'">
                                    </p-tag>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

        <!-- Accessories Details Card -->
        <div class="info-card" *ngIf="calculatedQuote.accessoriesConcepts && getAccessoriesDetails()">
            <div class="card-header">
                <i class="pi pi-plus-circle text-cyan-600"></i>
                <h3>Accesorios</h3>
                <div class="header-tags">
                    <p-tag value="Configurados" severity="info" class="ml-auto"></p-tag>
                </div>
            </div>
            <div class="card-content">
                <!-- Regular Accessories -->
                <div *ngIf="getAccessoriesDetails()?.cash && getAccessoriesDetails()!.cash.amount > 0" class="accessories-section">
                    <h4 class="section-subtitle">Accesorios de Contado</h4>
                    <div class="accessories-list">
                        <div class="accessory-item">
                            <div class="accessory-header">
                                <span class="accessory-name">Accesorios de Contado</span>
                                <p-tag value="Contado" severity="success" class="payment-tag"></p-tag>
                            </div>
                            <div class="accessory-details">
                                <span class="detail-item">
                                    <i class="pi pi-dollar text-green-600"></i>
                                    {{ getAccessoriesDetails()!.cash.total | currency }}
                                </span>
                                <span class="detail-item" *ngIf="getAccessoriesDetails()!.cash.concepts">
                                    <i class="pi pi-info-circle text-blue-600"></i>
                                    {{ getAccessoriesDetails()!.cash.concepts }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Financed Accessories -->
                <div *ngIf="getAccessoriesDetails()?.financed && getAccessoriesDetails()!.financed.total.amount > 0" class="accessories-section">
                    <h4 class="section-subtitle">Accesorios Financiados</h4>
                    <div class="accessories-list">
                        <div class="accessory-item">
                            <div class="accessory-header">
                                <span class="accessory-name">Accesorios Financiados</span>
                                <p-tag value="Financiado" severity="info" class="payment-tag"></p-tag>
                            </div>
                            <div class="accessory-details">
                                <span class="detail-item">
                                    <i class="pi pi-dollar text-green-600"></i>
                                    {{ getAccessoriesDetails()!.financed.total.total | currency }}
                                </span>
                                <span class="detail-item">
                                    <i class="pi pi-calendar text-blue-600"></i>
                                    {{ getAccessoriesDetails()!.financed.period.total | currency }} / período
                                </span>
                                <span class="detail-item" *ngIf="getAccessoriesDetails()!.financed.total.concepts">
                                    <i class="pi pi-info-circle text-blue-600"></i>
                                    {{ getAccessoriesDetails()!.financed.total.concepts }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- No data message -->
<div *ngIf="!calculatedQuote && !loading" class="no-data-container">
    <div class="no-data-card">
        <i class="pi pi-exclamation-triangle text-6xl text-orange-400"></i>
        <h3>Cotización no encontrada</h3>
        <p>No hay datos de cotización para mostrar</p>
    </div>
</div>

<p-dialog
    [(visible)]="showPdfOptionsDialog"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="pdf-confirm-dialog"
    header="Opciones de PDF">
    <div class="flex align-items-center gap-3">
        <i class="pi pi-file-pdf" style="font-size: 1.5rem"></i>
        <span>¿Deseas incluir el valor residual (opción de compra) en la cotización PDF?</span>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-between w-full">
            <button pButton type="button" label="Cancelar" icon="pi pi-times"
                class="p-button-outlined p-button-danger"
                (click)="closePdfDialog()"></button>
            <div class="flex gap-2">
                <button pButton type="button" label="No, omitir" icon="pi pi-minus-circle"
                    class="p-button-outlined"
                    (click)="generatePdf(false)"></button>
                <button pButton type="button" label="Sí, incluir" icon="pi pi-check-circle"
                    class="p-button-primary"
                    (click)="generatePdf(true)"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>
